<template>
  <div class="tasks-categorical">
    <OmxList
        :data="categories"
        :show-search="false"
        empty-icon="format-list-checks"
    >
      <template #actions>
        <b-button type="is-primary" icon-left="plus-thick" @click="addNewTaskCategoryClicked">
          {{ $t('common.add') }}
        </b-button>
      </template>

      <b-table-column :label="$t('categories-view.name')" v-slot="props">
        {{ props.row }}
      </b-table-column>
      <b-table-column v-slot="props" cell-class="has-text-right" width="120">
        <b-button type="is-danger" size="is-small" icon-left="delete"
                  @click="deleteCategoryClicked(props.row)">
          {{ $t('categories-view.delete') }}
        </b-button>
      </b-table-column>
    </OmxList>
  </div>
</template>

<script>
import OmxList from "@/components/OmxList.vue";

export default {
  name: "TasksCategorical",
  components: { OmxList },
  props: {
    categorical_data: {
      category: []
    }
  },
  data() {
    return {
      categories: []
    }
  },
  watch: {
    categorical_data: function () {
      this.categories = this.categorical_data.category
    }
  },
  methods: {
    deleteCategoryClicked(category) {
      const confirmBlock = () => {
        const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
        for (let i = categoriesToUpdate.length - 1; i >= 0; i--) {
          if (categoriesToUpdate[i] === category) categoriesToUpdate.splice(i, 1);
        }
        this.$emit('updateCategoricalData', {
          data: categoriesToUpdate,
          collectionName: "tasks",
          dataFieldTitle: "category"
        })
      }
      this.$emit('deleteCategoricalData', confirmBlock)
    },
    addNewTaskCategoryClicked() {
      const confirmBlock = (value) => {
        if (value !== '' && !this.categories.includes(value)) {
          const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
          categoriesToUpdate.push(value)
          this.$emit('updateCategoricalData', {
            data: categoriesToUpdate,
            collectionName: "tasks",
            dataFieldTitle: "category"
          })
        } else {
          this.showError(this.$t("categories-view.generic-add-element-error"))
        }
      }
      this.$emit('addCategoricalData', confirmBlock)
    }
  }
};
</script>
